import { useCallback, useState } from 'react';

import {
  type AccountDetailsState,
  formatDisplayName,
  getWorkspaceNameError,
  getWorkspaceNameHelperText,
} from '../signupUtils';

type UseWorkspaceNameFieldsOptions = {
  displayName: string;
  setField: (data: Partial<AccountDetailsState>) => void;
};

export const useWorkspaceNameFields = ({
  displayName,
  setField,
}: UseWorkspaceNameFieldsOptions) => {
  const [nameModified, setNameModified] = useState(false);
  const [nameBlurred, setNameBlurred] = useState(false);

  const handleDisplayNameChange = useCallback(
    (value: string) => {
      setNameModified(true);
      setField({ displayName: formatDisplayName(value) });
    },
    [setField],
  );

  const handleDisplayNameBlur = useCallback(() => {
    setNameModified(true);
    setNameBlurred(true);
  }, []);

  const nameFieldState = {
    displayName,
    isModified: nameModified,
    showLengthError: nameBlurred,
  };
  const validDisplayName = getWorkspaceNameError(nameFieldState) === undefined;
  const helperText = getWorkspaceNameHelperText(nameFieldState);

  return {
    handleDisplayNameChange,
    handleDisplayNameBlur,
    validDisplayName,
    helperText,
  };
};
